import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

export const RequireAdmin = ({ children, permission }) => {
  const { admin, checking, hasPermission } = useAdminAuth();
  const location = useLocation();

  if (checking) {
    return <div className="min-h-screen bg-[#0B0B0C]" data-testid="auth-checking" />;
  }
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  // Force first-login password change EXCEPT when already on /change-password
  if (admin.must_change_password && location.pathname !== '/admin/change-password') {
    return <Navigate to="/admin/change-password" replace />;
  }
  // Permission gate: when a route requires a specific permission, block if user lacks it
  if (permission && !hasPermission(permission)) {
    return (
      <div className="min-h-screen bg-[#0B0B0C] text-zinc-300 flex items-center justify-center p-6"
           data-testid="permission-denied">
        <div className="max-w-md text-center">
          <div className="text-[11px] tracking-widest text-zinc-500 mb-3">ACCESS DENIED</div>
          <h1 className="text-white text-2xl font-semibold mb-2">You don't have access to this section</h1>
          <p className="text-zinc-400 text-sm">Ask the account owner to grant you the
            <span className="text-white font-medium"> {permission} </span>
            permission in Settings → Team.</p>
        </div>
      </div>
    );
  }
  return children;
};
